import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-templates-forms',
  templateUrl: './templates-forms.component.html',
  styleUrls: ['./templates-forms.component.css']
})
export class TemplatesFormsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
